import type { IconSvgObject } from './types';

const ChartLineData01Icon: IconSvgObject = [
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21L10.5 8.5L15.5 13L19 5L21 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartLineData01Icon;
